(function () {
  var globalObject = window;

  globalObject.App = globalObject.App || {};

  if (globalObject.App.reviews) {
    return;
  }

  var API_BASE_URL = 'https://api.guaranteed-reviews.com/public/v3/reviews';
  var requestCache = Object.create(null);

  function getThemeReviewsSettings() {
    var themeSettings = globalObject.themeSettings || {};
    var reviewsSettings = themeSettings.reviews || {};

    return reviewsSettings;
  }

  function getPublicKey() {
    var publicKey = getThemeReviewsSettings().publicKey;
    if (typeof publicKey !== 'string') {
      return '';
    }
    return publicKey.trim();
  }

  function normalizeScope(scope) {
    if (scope === null || scope === undefined) {
      return '';
    }

    return String(scope).trim();
  }

  function buildCacheKey(publicKey, scope) {
    return publicKey + '-' + scope;
  }

  function buildApiUrl(publicKey, scope) {
    return [
      API_BASE_URL,
      encodeURIComponent(publicKey),
      encodeURIComponent(scope)
    ].join('/');
  }

  function createConfigurationError(message) {
    var error = new Error(message);
    error.name = 'ReviewsConfigurationError';

    return Promise.reject(error);
  }

  function createRequest(scope, publicKey) {
    return fetch(buildApiUrl(publicKey, scope), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Reviews request failed with status ' + response.status + '.');
      }

      return response.json();
    }).then(function (payload) {
      return {
        ratings: payload && payload.ratings ? payload.ratings : null,
        reviews: payload && Array.isArray(payload.reviews) ? payload.reviews : [],
        raw: payload || null
      };
    }).catch(function (error) {
      delete requestCache[buildCacheKey(publicKey, scope)];
      throw error;
    });
  }

  function getReviews(scope) {
    var normalizedScope = normalizeScope(scope);
    var publicKey = getPublicKey();
    var cacheKey;
    if (!publicKey) {
      return createConfigurationError('Missing Société des Avis Garantis public key.');
    }
    if (!normalizedScope) {
      return Promise.reject(new Error('Missing reviews scope.'));
    }

    cacheKey = buildCacheKey(publicKey, normalizedScope);
    if (!requestCache[cacheKey]) {
      requestCache[cacheKey] = createRequest(normalizedScope, publicKey);
    }
    return requestCache[cacheKey];
  }

  function getSiteReviews() {
    return getReviews('site');
  }

  function getProductReviews(productScope) {
    return getReviews(productScope);
  }

  function clearCache(scope) {
    var publicKey = getPublicKey();
    var normalizedScope = normalizeScope(scope);

    if (!publicKey) {
      requestCache = Object.create(null);
      return;
    }

    if (!normalizedScope) {
      requestCache = Object.create(null);
      return;
    }

    delete requestCache[buildCacheKey(publicKey, normalizedScope)];
  }

  globalObject.App.reviews = {
    getReviews: getReviews,
    getSiteReviews: getSiteReviews,
    getProductReviews: getProductReviews,
    clearCache: clearCache
  };
})();
